
export const toggleDarkMode = () => (dispatch, getState) => {
  const newState = !getState().darkMode;

  dispatch({
    type: 'TOGGLE_DARK_MODE',
    payload: newState
  })
}